<template src="./BrandInfo.html"></template>

<script>
import topMenu from '@/components/brand/components/topMenu';
import SearchQuery from '@/components/brand/info/components/SearchQuery';
import {createNamespacedHelpers} from 'vuex';

const {mapGetters, mapActions} = createNamespacedHelpers('brand/info')

export default {
  name: "BrandInfo",
  components: {
    topMenu,
    SearchQuery
  },
  data() {
    return {
      brandId: this.$route.params.id,
      brandName: '',
      brandDescription: '',
      brandGroup: '',
      brandSelected: '',
      fields: [
        {
          key: 'periodName',
          label: 'Период'
        },
        {
          key: 'demandForecast',
          label: 'Пр. Спрос'
        },
        {
          key: 'applications',
          label: 'Заявки'
        },
        {
          key: 'efficiency',
          label: 'Эфф.'
        },
        {
          key: 'conversion',
          label: 'Конв.'
        },
        {
          key: 'averageCheck',
          label: 'Ср. Чек'
        },
        {
          key: 'MPR',
          label: 'MPR'
        }
      ],
      isEditOnSite: false,
      optionsStatus: [
        {value: null, text: ''},
        {value: 'хорошо', text: 'Хорошо'},
        {value: 'средний', text: 'Средний'},
        {value: 'плохо', text: 'Плохо'},
      ],
      showOverlay: 0,
      comment: '',
      tagsInit: false,
      hints: {
        productCount: 'Всего товаров по бренду [шт]',
        productCategoryCount: 'Количество товаров с заполненными категориям [шт]',
        categoryCount: 'Количество уникальных категорий товаров бренда [шт]',
        productDescription: 'Количество товаров с хоть одним заполненным описанием на любом языке [шт]',
        productShortDescription: 'Количество товаров с хоть одним заполненным кратким описанием на любом языке [шт]',
        productCharacteristics: 'Количество товаров с хоть одним заполненным характеристиками на любом языке [шт]',
        productPages: 'Количество товаров, где Флаг Seo не равен нулю [шт]',
        parentProductsCount: 'Количество товаров со статусом “Родительский” [шт]',
        childProductsCount: 'Количество товаров со статусом “Дочерний” [шт]',
        productsShop: 'Количество товаров со статусом true в поле “Shop” [шт]',
        productsOnline: 'Количество товаров со статусом true в поле “Online” [шт]',
        productsPurchasePrice: 'Количество SKU у которых заполнено поле “Цена закупки” [шт]',
        productsCompetitorPrice: 'Количество SKU у которых заполнено поле “Цена конкурентов” [шт]',
        productsCrmPrice: 'Количество SKU у которых заполнено поле “цена CRM” [шт]',
        productsSupplierWarehouse: 'Количество SKU у которых заполнено поле “Склад поставщика” [шт]',
        productsOwnWarehouse: 'Количество SKU у которых заполнено поле “Свой склад” [шт]',
        productsLastOrderDate: 'Количество SKU у которых заполнено поле “Дата последнего заказа” [шт]',
        productsPhotos: 'Количество товаров с хоть одним фото [шт]'
      }
    }
  },
  methods: {
    ...mapActions([
      'GET_INFO',
      'GET_GROUPS',
      'GET_COUNTRIES',
      'GET_BRANDS',
      'ADD_COMMENT',
      'GET_COMMENTS',
      'SAVE',
      'FREQUENCY_UPDATE',
    ]),
    editOnSite: function () {
      this.isEditOnSite = true;
      setTimeout(() => {
        this.$refs.onOurSite.focus();
      }, 100);
    },
    addComment: function () {
      if (this.comment == '') {
        return;
      }
      this.ADD_COMMENT({
        th: this,
        brandId: this.brandId,
        message: this.comment,
        handleSuccessResponse: () => {
          this.comment = ''
        },
      });
    },
    nFormat: function (number, afterDot = 0) {
      if (number === null || number === '') {
        return 'н/д';
      }
      number = Number(number);
      afterDot = number > 10 ? 0 : afterDot;// todo ???
      return new Intl.NumberFormat('ru-RU').format(Number((number).toFixed(afterDot)));
    },
    save: function () {
      this.SAVE({
        th: this, handleSuccessResponse: () => {
          this.GET_INFO({id: this.brandId, th: this});
        }
      });
    },
    frequencyUpdate: async function (type) {
      if (this.$refs['but-frequency-update-'+ type].classList.contains('toggle')) {
        return false
      }
      await this.SAVE({
        th: this, handleSuccessResponse: () => {
          this.$refs['but-frequency-update-'+ type].classList.add('toggle');
          this.FREQUENCY_UPDATE({th: this, type: type});
        }
      });
    },
    toggleButUpdate: function (type) {
      this.$refs['but-frequency-update-'+ type].classList.remove('toggle');
    },
    change: function () {
      this.$store.commit('brand/info/HAVE_CHANGE', true)
    },
    input: function () {
      if (this.tagsInit) {
        this.change()
      }
      this.tagsInit = true
    },
    setLogo: async function () {
      this.change();
      const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });

      let file = this.$refs.brand_logo_input.files[0]
      let data = await toBase64(file)
      this.BRAND.logo = data
    }
  },
  computed: {
    ...mapGetters([
      'BRAND',
      'GROUP_LIST',
      'COUNTRY_LIST',
      'BRAND_LIST',
      'COMMENT_LIST',
      'IS_SEND_ALREADY',
      'HAVE_CHANGE',
    ]),
    getGroup: function () {
      let options = [];
      this.GROUP_LIST.forEach((val) => {
        options.push({value: val.id, text: val.name});
      });
      return options;
    },
    getCountry: function () {
      let options = [];
      this.COUNTRY_LIST.forEach((val) => {
        options.push({value: val.id, text: val.name});
      });
      return options;
    },
    getBrand: function () {
      let options = [];
      this.BRAND_LIST.forEach((val) => {
        options.push({value: val.id, text: val.name});
      });
      return options;
    },
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('brand') === -1) {
      this.$router.push({name: 'permissionDenied'});
      return;
    }
  },
  created() {
    if (this.IS_SEND_ALREADY != this.brandId) {
      this.GET_INFO({id: this.brandId, th: this});
      this.GET_GROUPS({th: this});
      this.GET_COUNTRIES({th: this});
      this.GET_BRANDS({th: this});
      this.GET_COMMENTS({brandId: this.brandId, th: this});
      this.$store.commit('brand/info/IS_SEND_ALREADY', this.brandId);
    }
  }
}
</script>

<style scoped>
#inputDescription textarea {
  height: 150px;
}

.container {
  padding-top: 60px;
  padding-bottom: 300px;
}

.edit-page label {
  text-align: left;
  font-size: 17px;
  font-weight: 600;
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

.part-border {
  border-bottom: 2px solid;
  margin-bottom: 15px;
}

.dot {
  min-width: 53px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  line-height: 50px;
  margin-top: -25px;
  border: 1px solid #000;
}

.micro-button {
  padding: 2px 4px;
  line-height: 15px;
}

.overlay {
  margin-top: -20px;
  padding: 20px;
}

.but-add-comment {
  float: right;
}

.comment-area {
  max-height: 400px;
  overflow-y: auto;
}

.query-aria {
  height: 115px;
  overflow-y: auto;
}

.dot-red {
  background-color: red;
}

.dot-yellow {
  background-color: #FEFB64;
}

.dot-blue {
  background-color: #0099F9;
}

.dot-green {
  background-color: #72BB53;
}

.toggle .waiting-state {
  display: none;
}

.toggle .process-state {
  display: inline;
}
.process-state {
  display: none;
}

</style>

<style>
.table .thead-dark th {
  font-size: 14px;
}

.brand-info .col-1, .brand-info .col-2, .brand-info .col-3, .brand-info .col-4, .brand-info .col-5, .brand-info .col-6, .brand-info .col-7, .brand-info .col-8, .brand-info .col-9, .brand-info .col-10, .brand-info .col-11, .brand-info .col-12, .brand-info .col, .brand-info .col-auto, .brand-info .col-sm-1, .brand-info .col-sm-2, .brand-info .col-sm-3, .brand-info .col-sm-4, .brand-info .col-sm-5, .brand-info .col-sm-6, .brand-info .col-sm-7, .brand-info .col-sm-8, .brand-info .col-sm-9, .brand-info .col-sm-10, .brand-info .col-sm-11, .brand-info .col-sm-12, .brand-info .col-sm, .brand-info .col-sm-auto, .brand-info .col-md-1, .brand-info .col-md-2, .brand-info .col-md-3, .brand-info .col-md-4, .brand-info .col-md-5, .brand-info .col-md-6, .brand-info .col-md-7, .brand-info .col-md-8, .brand-info .col-md-9, .brand-info .col-md-10, .brand-info .col-md-11, .brand-info .col-md-12, .brand-info .col-md, .brand-info .col-md-auto, .brand-info .col-lg-1, .brand-info .col-lg-2, .brand-info .col-lg-3, .brand-info .col-lg-4, .brand-info .col-lg-5, .brand-info .col-lg-6, .brand-info .col-lg-7, .brand-info .col-lg-8, .brand-info .col-lg-9, .brand-info .col-lg-10, .brand-info .col-lg-11, .brand-info .col-lg-12, .brand-info .col-lg, .brand-info .col-lg-auto, .brand-info .col-xl-1, .brand-info .col-xl-2, .brand-info .col-xl-3, .brand-info .col-xl-4, .brand-info .col-xl-5, .brand-info .col-xl-6, .brand-info .col-xl-7, .brand-info .col-xl-8, .brand-info .col-xl-9, .brand-info .col-xl-10, .brand-info .col-xl-11, .brand-info .col-xl-12, .brand-info .col-xl, .brand-info .col-xl-auto {
  padding-right: 5px;
  padding-left: 5px;
}

.brand-info .card-body {
  padding: 0.5rem;
}

.search-data .card-body {
  padding-right: 0px;
  padding-left: 0px;
}

.col-p-8 .col-auto {
  padding-right: 8px;
  padding-left: 8px;
}

.brand-info .form-group {
  margin-bottom: 10px;
}

.brand-info .d-block {
  margin-bottom: 0px;
}

.tag-button .btn {
  margin: 3px 5px;
}

.brand-info .form-control, .brand-info .custom-select {
  font-size: 16px;
}

.brand-info .custom-select.frequency-status {
  font-size: 14px;
}

.brand-info label {
  font-size: 14px;
  color: grey;
  display: block;
}

.brand-info .b-form-tag {
  font-size: 95%;
}
.comment-text {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: 400;
}
.hint-icon{
  display: inline-block;
  cursor: pointer;
}
</style>